import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { isNumber } from 'lodash'
import * as React from 'react'

import { Icon } from '#/components/Icon'
import { verifyIfOutdated } from '#/components/OutdatedData/rules'
import ValueVariationWrapper from '#/components/ValueVariationWrapper'
import Palette from '#/styles/Old/Palette'
import precise from '#/utils/numberPrecise'

const sxStyles = {
  value: {
    'fontSize': 14,
    'fontWeight': 500,
    '& .MuiSvgIcon-root': {
      fontSize: 14,
    },
  },
}

/**
 * If the value is greater than 0, return green, otherwise return red
 * @param value - The value of the chip.
 * @param reverse - If true, the chip will be green if the value is negative and red if the value is
 * positive.
 * @returns A function that returns an object.
 */
// function chipStyle(value, reverse) {
//   if (!isNumber(value)) return {}

//   const green = {
//     color: Palette.green.accent[4],
//     backgroundColor: Palette.green.lighten[5],
//   }
//   const red = {
//     color: Palette.red.accent[4],
//     backgroundColor: Palette.red.lighten[5],
//   }

//   if (reverse) {
//     return value > 0 ? red : green
//   }
//   return value > 0 ? green : red
// }

/**
 * It renders a label for the variation, with optional prefix, suffix, and precision
 * @param props - The props passed to the component.
 * @param styles - This is the styles object that is passed to the component.
 * @returns A function that returns a Stack component.
 */
const renderLabel = props => {
  const { variation, precision = 1, suffix, prefix, reverse } = props

  let formattedPrefix = prefix

  if (!prefix && isNumber(variation) && prefix !== false) {
    if (reverse) {
      formattedPrefix =
        variation > 0 ? <Icon size="large" name="south" /> : <Icon size="large" name="north" />
    } else {
      formattedPrefix =
        variation > 0 ? <Icon size="large" name="north" /> : <Icon size="large" name="south" />
    }
  }

  const stackProps = {
    direction: 'row',
    spacing: 0.5,
    alignItems: 'center',
  }

  return (
    <Stack {...stackProps} sx={sxStyles.value}>
      {prefix !== false && <span style={{ display: 'flex' }}>{formattedPrefix}</span>}
      <span>{precise(variation, precision)}</span>
      {suffix}
    </Stack>
  )
}

/**
 * If the subtype prop is chip, return a StatisticChip component, if the subtype prop is card, return a
 * StatisticCard component, otherwise return null.
 * @returns A component
 */

const TypeStatistic = ({ subtype, ...rest }) => {
  switch (subtype) {
    case 'text':
      return <StatisticText {...rest} />

    default:
      return <StatisticChip {...rest} />
  }
}

const StatisticText = props => {
  const { value, reverse } = props
  let color
  if (isNumber(value)) {
    if (reverse) {
      color = value > 0 ? Palette.red.accent[4] : Palette.green.accent[4]
    } else {
      color = value > 0 ? Palette.green.accent[4] : Palette.red.accent[4]
    }
  }

  return <Typography sx={{ color }}>{renderLabel(props)}</Typography>
}

/**
 * It renders a Chip with a value, prefix, suffix, and precision
 * @returns A React component that renders a Chip component with a startDecorator and endDecorator.
 */
const StatisticChip = props => {
  const { value, variation, timestamp, rules } = props
  const isOutdated = timestamp && rules ? verifyIfOutdated({ rules, timestamp }) : false

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <ValueVariationWrapper variation={variation} isOutdated={isOutdated}>
        {value ?? '-'}
      </ValueVariationWrapper>
    </Stack>
  )
}

export default TypeStatistic
